import { Button, Col, Divider, Input, Modal, Row } from 'antd'
import { useParams } from 'react-router-dom'
import {
  useFetchCharacterQuery,
  useUpdateCharacterMutation,
  useUpdateInviteMutation,
} from '../../store'
import {
  GiAngelOutfit,
  GiWorld,
  GiSnake,
  GiPoliceBadge,
  GiThreeFriends,
  GiBrain,
  GiWeightLiftingUp,
  GiMuscleUp,
  GiSmart,
  GiArcheryTarget,
  GiSpy,
  GiFist,
  GiDiscobolus,
  GiBrainFreeze,
  GiBookCover,
  GiComputing,
  GiToolbox,
  GiMagnifyingGlass,
  GiHealthNormal,
  GiPentacle,
  GiDiploma,
  GiAtom,
  GiSwordsEmblem,
  GiCityCar,
  GiKimono,
  GiIdCard,
  GiPistolGun,
  GiPayMoney,
  GiNinjaHead,
  GiJumpAcross,
  GiCampfire,
  GiSittingDog,
  GiCherish,
  GiVitruvianMan,
  GiAngryEyes,
  GiConversation,
  GiShakingHands,
  GiDominoMask,
  GiRobber,
  GiClover,
  GiSkullCrack,
  GiBodyHeight,
  GiSpeedometer,
  GiStairsGoal,
  GiSurroundedShield,
  GiChestArmor,
  GiClockwork,
  GiHearts,
  GiDoubleFaceMask,
  GiDove,
  GiSwitchWeapon,
  GiHeavyHelm,
  GiSwapBag,
} from 'react-icons/gi'
import { AttributeCard } from '../../components/AttributeCard'
import { FadeIn } from '../../components/FadeIn'
import { useEffect, useState } from 'react'
import { Overlay } from '../../components/Overlay'

import * as S from './style'

export const CharacterDetailsPage = () => {
  const { id } = useParams()
  const { data: character, isLoading, refetch, isFetching } = useFetchCharacterQuery(id)
  const [openInviteModal, setOpenInviteModal] = useState(false)
  const [inviteCode, setInviteCode] = useState('')
  const [updateCharacterData, characterData] = useUpdateCharacterMutation()
  const [acceptInvite, inviteData] = useUpdateInviteMutation()
  const characterWeapons = character?.items?.filter((item: any) => item.weapon)
  const characterArmor = character?.items?.filter((item: any) => item.armor)
  const characterItems = character?.items?.filter((item: any) => !item.weapon && !item.armor)

  const handleAttributeUpdate = (attribute: string, newValue: number) => {
    updateCharacterData({ [attribute]: newValue, id: character.id })
  }

  const handleRemoveConditions = (id: string) => {
    const conditions = [...character.conditions]
    const index = conditions.findIndex((condition) => condition.id === id)
    conditions[index] = { ...conditions[index], markedForDeletion: true }

    updateCharacterData({ conditions, id: character.id })
  }

  const handleSkillsAndMeritsUpdate = (
    attribute: string,
    newValue: number,
    type: 'skills' | 'merits',
  ) => {
    let s: any[] = []

    if (type === 'skills') {
      s = [...character.skills]
    }

    if (type === 'merits') {
      s = [...character.merits]
    }
    const index = s.findIndex((skillMerit) => skillMerit.description === attribute)
    s[index] = { ...s[index], level: newValue.toString() }

    updateCharacterData({ [type]: s, id: character.id })
  }

  useEffect(() => {
    if (characterData.isSuccess) refetch()
  }, [characterData])

  useEffect(() => {
    if (inviteData.isSuccess) refetch()
  }, [inviteData])

  return (
    <Overlay isLoading={isLoading}>
      {character && !isLoading && (
        <FadeIn>
          <Overlay isLoading={characterData.isLoading || inviteData.isLoading || isFetching}>
            <>
              <Row justify={'center'}>
                <Col>
                  <Row justify={'center'}>
                    <S.CharacterName style={{ margin: 0 }}>{character.name}</S.CharacterName>
                  </Row>
                  <Row justify={'center'}>
                    <S.CharacterConcept>{character.concept}</S.CharacterConcept>
                  </Row>
                </Col>
              </Row>
              <Divider style={{ marginTop: 12 }} />
              <Row justify={'center'} gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <AttributeCard
                    icon={<GiWorld size={48} />}
                    type={'Adventure'}
                    attribute={character.chronicle?.name || 'N/A'}
                    stars={false}
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <AttributeCard
                    icon={<GiIdCard size={48} />}
                    type={'Age'}
                    stars={false}
                    attribute={character.age}
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <AttributeCard
                    icon={<GiAngelOutfit size={48} />}
                    type={'Virtue'}
                    attribute={character.virtue}
                    stars={false}
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <AttributeCard
                    icon={<GiSnake size={48} />}
                    type={'Vice'}
                    attribute={character.vice}
                    stars={false}
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <AttributeCard
                    icon={<GiPoliceBadge size={48} />}
                    type={'Faction'}
                    attribute={character.faction}
                    stars={false}
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <AttributeCard
                    icon={<GiThreeFriends size={48} />}
                    type={'Group'}
                    attribute={character.group_name}
                    stars={false}
                  />
                </Col>
              </Row>
              <Divider />
              <Col>
                <Row justify={'center'}>
                  <S.SectionTitle>Basic Info</S.SectionTitle>
                </Row>
                <Row justify={'center'} gutter={[16, 16]}>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiBodyHeight size={48} />}
                      type={'Size'}
                      attribute={character.size}
                      margin={'8px 0'}
                      stars={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiSpeedometer size={48} />}
                      type={'Speed'}
                      attribute={character.speed}
                      margin={'8px 0'}
                      stars={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiStairsGoal size={48} />}
                      type={'Initiative'}
                      attribute={character.initiative}
                      margin={'8px 0'}
                      stars={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiSurroundedShield size={48} />}
                      type={'Defense'}
                      attribute={character.defense}
                      margin={'8px 0'}
                      stars={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiChestArmor size={48} />}
                      type={'Armor'}
                      attribute={character.armor}
                      margin={'8px 0'}
                      editable
                      editHook={(value: number) => handleAttributeUpdate('armor', value)}
                      stars={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiHearts size={48} />}
                      type={'Health'}
                      attribute={character.current_health}
                      levelCap={character.max_health}
                      margin={'8px 0'}
                      editable
                      editHook={(value: number) => handleAttributeUpdate('current_health', value)}
                      stars={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiDove size={48} />}
                      type={'Willpower'}
                      attribute={character.current_willpower}
                      levelCap={character.max_willpower}
                      margin={'8px 0'}
                      editable
                      editHook={(value: number) =>
                        handleAttributeUpdate('current_willpower', value)
                      }
                      stars={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiDoubleFaceMask size={48} />}
                      type={'Integrity'}
                      attribute={character.integrity}
                      margin={'8px 0'}
                      editable
                      levelCap={'10'}
                      editHook={(value: number) => handleAttributeUpdate('integrity', value)}
                      stars={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <AttributeCard
                      icon={<GiClockwork size={48} />}
                      type={'Experience'}
                      attribute={character.experience}
                      margin={'8px 0'}
                      editable
                      editHook={(value: number) => handleAttributeUpdate('experience', value)}
                      stars={false}
                    />
                  </Col>
                </Row>
              </Col>
              <Divider />
              <Row justify={'center'}>
                <S.SectionTitle>Attributes</S.SectionTitle>
              </Row>
              <Row justify={'center'} gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <Row justify={'center'}>
                    <Col>
                      <Row justify={'center'}>
                        <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Power</span>
                      </Row>
                    </Col>
                  </Row>
                  <AttributeCard
                    icon={<GiBrain size={48} />}
                    type={'Intelligence'}
                    attribute={character.intelligence}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('intelligence', value)}
                  />
                  <AttributeCard
                    icon={<GiWeightLiftingUp size={48} />}
                    type={'Strength'}
                    attribute={character.strength}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('strength', value)}
                  />
                  <AttributeCard
                    icon={<GiMuscleUp size={48} />}
                    type={'Presence'}
                    attribute={character.presence}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('presence', value)}
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <Row justify={'center'}>
                    <Col>
                      <Row justify={'center'}>
                        <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Finesse</span>
                      </Row>
                    </Col>
                  </Row>
                  <AttributeCard
                    icon={<GiSmart size={48} />}
                    type={'Wits'}
                    attribute={character.wits}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('wits', value)}
                  />
                  <AttributeCard
                    icon={<GiArcheryTarget size={48} />}
                    type={'Dexterity'}
                    attribute={character.dexterity}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('dexterity', value)}
                  />
                  <AttributeCard
                    icon={<GiSpy size={48} />}
                    type={'Manipulation'}
                    attribute={character.manipulation}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('manipulation', value)}
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <Row justify={'center'}>
                    <Col>
                      <Row justify={'center'}>
                        <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Resistance</span>
                      </Row>
                    </Col>
                  </Row>
                  <AttributeCard
                    icon={<GiFist size={48} />}
                    type={'Resolve'}
                    attribute={character.resolve}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('resolve', value)}
                  />
                  <AttributeCard
                    icon={<GiDiscobolus size={48} />}
                    type={'Stamina'}
                    attribute={character.stamina}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('stamina', value)}
                  />
                  <AttributeCard
                    icon={<GiBrainFreeze size={48} />}
                    type={'Composure'}
                    attribute={character.composure}
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) => handleAttributeUpdate('composure', value)}
                  />
                </Col>
              </Row>
              <Divider />
              <Row justify={'center'}>
                <S.SectionTitle>Skills</S.SectionTitle>
              </Row>
              <Row justify={'center'} gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <Row justify={'center'}>
                    <Col>
                      <Row justify={'center'}>
                        <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Mental</span>
                      </Row>
                      <Row justify={'center'}>
                        <span
                          style={{
                            fontFamily: 'HonestMaria',
                            fontSize: 24,
                            margin: '-16px 0 0',
                            color: '#999999',
                          }}
                        >
                          (-3 unskilled)
                        </span>
                      </Row>
                    </Col>
                  </Row>
                  <AttributeCard
                    icon={<GiBookCover size={48} />}
                    type={'Academics'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Academics').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Academics', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiComputing size={48} />}
                    type={'Computer'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Computer').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Computer', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiToolbox size={48} />}
                    type={'Crafts'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Crafts').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Crafts', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiMagnifyingGlass size={48} />}
                    type={'Investigation'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Investigation')
                        .level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Investigation', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiHealthNormal size={48} />}
                    type={'Medicine'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Medicine').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Medicine', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiPentacle size={48} />}
                    type={'Occult'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Occult').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Occult', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiDiploma size={48} />}
                    type={'Politics'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Politics').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Politics', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiAtom size={48} />}
                    type={'Science'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Science').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Science', value, 'skills')
                    }
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <Row justify={'center'}>
                    <Col>
                      <Row justify={'center'}>
                        <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Physical</span>
                      </Row>
                      <Row justify={'center'}>
                        <span
                          style={{
                            fontFamily: 'HonestMaria',
                            fontSize: 24,
                            margin: '-16px 0 0',
                            color: '#999999',
                          }}
                        >
                          (-1 unskilled)
                        </span>
                      </Row>
                    </Col>
                  </Row>
                  <AttributeCard
                    icon={<GiJumpAcross size={48} />}
                    type={'Athletics'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Athletics').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Athletics', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiKimono size={48} />}
                    type={'Brawl'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Brawl').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Brawl', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiCityCar size={48} />}
                    type={'Drive'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Drive').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Drive', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiPistolGun size={48} />}
                    type={'Firearms'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Firearms').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Firearms', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiRobber size={48} />}
                    type={'Larceny'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Larceny').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Larceny', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiNinjaHead size={48} />}
                    type={'Stealth'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Stealth').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Stealth', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiCampfire size={48} />}
                    type={'Survival'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Survival').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Survival', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiSwordsEmblem size={48} />}
                    type={'Weaponry'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Weaponry').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Weaponry', value, 'skills')
                    }
                  />
                </Col>
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <Row justify={'center'}>
                    <Col>
                      <Row justify={'center'}>
                        <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Social</span>
                      </Row>
                      <Row justify={'center'}>
                        <span
                          style={{
                            fontFamily: 'HonestMaria',
                            fontSize: 24,
                            margin: '-16px 0 0',
                            color: '#999999',
                          }}
                        >
                          (-1 unskilled)
                        </span>
                      </Row>
                    </Col>
                  </Row>
                  <AttributeCard
                    icon={<GiSittingDog size={48} />}
                    type={'Animal Ken'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Animal Ken')
                        .level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Animal Ken', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiCherish size={48} />}
                    type={'Empathy'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Empathy').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Empathy', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiVitruvianMan size={48} />}
                    type={'Expression'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Expression')
                        .level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Expression', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiAngryEyes size={48} />}
                    type={'Intimidation'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Intimidation')
                        .level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Intimidation', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiShakingHands size={48} />}
                    type={'Persuasion'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Persuasion')
                        .level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Persuasion', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiConversation size={48} />}
                    type={'Socialize'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Socialize').level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Socialize', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiPayMoney size={48} />}
                    type={'Streetwise'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Streetwise')
                        .level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Streetwise', value, 'skills')
                    }
                  />
                  <AttributeCard
                    icon={<GiDominoMask size={48} />}
                    type={'Subterfuge'}
                    attribute={
                      character.skills.find((skill: any) => skill.description === 'Subterfuge')
                        .level
                    }
                    margin={'8px 0'}
                    levelCap={'5'}
                    editable
                    editHook={(value: number) =>
                      handleSkillsAndMeritsUpdate('Subterfuge', value, 'skills')
                    }
                  />
                </Col>
              </Row>
              <Divider />
              <Row justify={'center'}>
                <S.SectionTitle>Other Traits</S.SectionTitle>
              </Row>
              <Col>
                <Row justify={'center'}>
                  <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Merits</span>
                </Row>
                <Row justify={'center'} gutter={[16, 16]}>
                  {character.merits.length ? (
                    character.merits.map((merit: any) => {
                      return (
                        <Col xs={24} sm={12} md={6} xxl={4} key={merit.id}>
                          <AttributeCard
                            icon={<GiClover size={48} />}
                            type={merit.description}
                            attribute={merit.level}
                            margin={'8px 0'}
                            editable
                            editHook={(value: number) =>
                              handleSkillsAndMeritsUpdate(merit.description, value, 'merits')
                            }
                            stars={false}
                          />
                        </Col>
                      )
                    })
                  ) : (
                    <S.EmptyDivider> No Merits </S.EmptyDivider>
                  )}
                </Row>
              </Col>
              <Col>
                <Row justify={'center'} style={{ marginTop: 24 }}>
                  <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Conditions</span>
                </Row>
                <Row justify={'center'} gutter={[16, 16]}>
                  {character.conditions.length ? (
                    character.conditions.map((condition: any) => {
                      return (
                        <Col xs={24} sm={12} md={6} xxl={4} key={condition.id}>
                          <AttributeCard
                            icon={<GiSkullCrack size={48} />}
                            type={condition.description}
                            attribute={condition.reason}
                            margin={'8px 0'}
                            removable
                            editHook={(_) => handleRemoveConditions(condition.id)}
                            stars={false}
                          />
                        </Col>
                      )
                    })
                  ) : (
                    <S.EmptyDivider> No Conditions </S.EmptyDivider>
                  )}
                </Row>
              </Col>
              <Row justify={'center'} style={{ marginTop: 24 }}>
                <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Weapons</span>
              </Row>
              <Row justify={'center'} gutter={[16, 16]}>
                {characterWeapons.length ? (
                  characterWeapons.map((item: any) => {
                    return (
                      <Col xs={24} sm={12} md={6} xxl={4} key={item.id}>
                        <AttributeCard
                          icon={<GiSwitchWeapon size={48} />}
                          type={item.description}
                          attribute={item.modifiers}
                          margin={'8px 0'}
                          stars={false}
                        />
                      </Col>
                    )
                  })
                ) : (
                  <S.EmptyDivider> No Weapons </S.EmptyDivider>
                )}
              </Row>
              <Row justify={'center'} style={{ marginTop: 24 }}>
                <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Armor</span>
              </Row>
              <Row justify={'center'} gutter={[16, 16]}>
                {characterArmor.length ? (
                  characterArmor.map((item: any) => {
                    return (
                      <Col xs={24} sm={12} md={6} xxl={4} key={item.id}>
                        <AttributeCard
                          icon={<GiHeavyHelm size={48} />}
                          type={item.description}
                          attribute={item.modifiers}
                          margin={'8px 0'}
                          stars={false}
                        />
                      </Col>
                    )
                  })
                ) : (
                  <S.EmptyDivider> No Armor </S.EmptyDivider>
                )}
              </Row>
              <Row justify={'center'} style={{ marginTop: 24 }}>
                <span style={{ fontFamily: 'HonestMaria', fontSize: 36 }}>Items</span>
              </Row>
              <Row justify={'center'} gutter={[16, 16]}>
                {characterItems.length ? (
                  character.items
                    .filter((item: any) => !item.weapon && !item.armor)
                    .map((item: any) => {
                      return (
                        <Col xs={24} sm={12} md={6} xxl={4} key={item.id}>
                          <AttributeCard
                            icon={<GiSwapBag size={48} />}
                            type={item.description}
                            attribute={item.modifiers}
                            margin={'8px 0'}
                            stars={false}
                          />
                        </Col>
                      )
                    })
                ) : (
                  <S.EmptyDivider> No Items </S.EmptyDivider>
                )}
              </Row>
              <Row justify={'center'} gutter={[16, 16]} style={{ marginTop: 36 }}>
                {character.chronicle_id && (
                  <Col xs={24} sm={12} md={6} xxl={4}>
                    <Button
                      style={{ width: '100%' }}
                      type={'primary'}
                      danger
                      onClick={() => updateCharacterData({ id: character.id, chronicle_id: null })}
                    >
                      Leave Adventure
                    </Button>
                  </Col>
                )}
                <Col xs={24} sm={12} md={6} xxl={4}>
                  <Button
                    style={{ width: '100%' }}
                    type={'primary'}
                    onClick={() => setOpenInviteModal(true)}
                  >
                    Accept Adventure Invite
                  </Button>
                </Col>
                <Modal
                  title={'Accept Adventure Invite'}
                  open={openInviteModal}
                  onOk={() => {
                    acceptInvite({ invite_id: inviteCode, character_id: character.id })
                    setOpenInviteModal(false)
                  }}
                  onCancel={() => setOpenInviteModal(false)}
                >
                  <label style={{ fontWeight: 'bold' }}>Invite Code</label>
                  <Input
                    onChange={({ target: { value } }: any) => setInviteCode(value)}
                    value={inviteCode}
                    placeholder={'Invite Code'}
                  />
                  <div style={{ margin: '16px 0' }}>
                    PS: If you are already enrolled in an adventure, you will be transferred to the
                    one from the invite.
                  </div>
                </Modal>
              </Row>
            </>
          </Overlay>
        </FadeIn>
      )}
    </Overlay>
  )
}
